import { NavLink } from '@mantine/core';
import { NavLink as RouterNavLink } from 'react-router-dom';
import {
  IconHome,
  IconUsers,
  IconUsersGroup,
  IconPlaneTilt,
  IconReportAnalytics,
  IconTrain,
  IconFlag,
  IconLanguage,
  IconMapPin,
  IconBed,
  IconUserShield,
  IconUserCog,
  IconMail,
} from '@tabler/icons-react';
import { useAuthStore, hasAnyRole } from '../auth/store.ts';

interface Link {
  to: string;
  label: string;
  icon: React.ReactNode;
  authority?: string;
}

// Permissions mirror the legacy navbar
// (src/main/webapp/app/layouts/navbar/navbar.component.html):
//   Home, Travels       → any authenticated user
//   Train Booking       → ROLE_USER
//   Government Form     → ROLE_GOVERNMENT_FORM
//   Visitors, Groups    → ROLE_ADMIN (under Admin Entities in legacy)
//   Reference + Users   → ROLE_ADMIN
const PRIMARY: Link[] = [
  { to: '/', label: 'Home', icon: <IconHome size={18} /> },
  { to: '/travels', label: 'Travels', icon: <IconPlaneTilt size={18} /> },
  { to: '/train', label: 'Train Booking', icon: <IconTrain size={18} />, authority: 'ROLE_USER' },
  { to: '/gov-form', label: 'Government Form', icon: <IconReportAnalytics size={18} />, authority: 'ROLE_GOVERNMENT_FORM' },
  { to: '/visitors', label: 'Visitors', icon: <IconUsers size={18} />, authority: 'ROLE_ADMIN' },
  { to: '/visitor-groups', label: 'Groups', icon: <IconUsersGroup size={18} />, authority: 'ROLE_ADMIN' },
];

const REFERENCE: Link[] = [
  { to: '/countries', label: 'Countries', icon: <IconFlag size={18} />, authority: 'ROLE_ADMIN' },
  { to: '/languages', label: 'Languages', icon: <IconLanguage size={18} />, authority: 'ROLE_ADMIN' },
  { to: '/locations', label: 'Locations', icon: <IconMapPin size={18} />, authority: 'ROLE_ADMIN' },
  { to: '/accomodation-places', label: 'Accommodation', icon: <IconBed size={18} />, authority: 'ROLE_ADMIN' },
  { to: '/roles', label: 'Roles', icon: <IconUserShield size={18} />, authority: 'ROLE_ADMIN' },
  { to: '/users', label: 'Users', icon: <IconUserCog size={18} />, authority: 'ROLE_ADMIN' },
  { to: '/report-mails', label: 'Report Mails', icon: <IconMail size={18} />, authority: 'ROLE_ADMIN' },
];

export function Navbar({ onNavigate }: { onNavigate?: () => void } = {}) {
  const user = useAuthStore(s => s.user);
  const linkFor = (l: Link) => (
    <NavLink
      key={l.to}
      component={RouterNavLink}
      to={l.to}
      label={l.label}
      leftSection={l.icon}
      onClick={() => onNavigate?.()}
    />
  );
  const visible = (l: Link) => !l.authority || hasAnyRole(user, l.authority);
  return (
    <>
      {PRIMARY.filter(visible).map(linkFor)}
      {REFERENCE.some(visible) && (
        <>
          <div style={{ height: 12 }} />
          {REFERENCE.filter(visible).map(linkFor)}
        </>
      )}
    </>
  );
}
